import api from 'Application/api/api';

const deleteGroupInstructionAssignment = (id, cancelToken = null) =>
    api.delete(`/education/instruction-assignments/group/${id}`, {
        cancelToken,
    });

export default deleteGroupInstructionAssignment;
